export default {
  Helptext1: "Mehrere Suchbegriffe können durch Leerzeichen getrennt werden.",
  Helptext2: "Mit Anführungszeichen '...' kann nach einer exakten Zeichenfolge gesucht werden.",
  Helptext3: "Es ist auch möglich nach mehreren exakten Zeichenfolgen '...' '...' '...' zu suchen.",
  undefined: "Nicht definiert",
  globalErrorMessageHeader: "Fehler",
  globalErrorMessage:
    "Während Ihrer Anfrage ist ein Fehler aufgetreten und der IT-Support wurde informiert. Wir werden dieses Problem so schnell wie möglich beheben und entschuldigen uns für die Unannehmlichkeiten.",
  SelectOrCreateAttribute1: "Wählen oder ",
  SelectOrCreateAttribute2: "Sie ein Attribut, um seine Parameter zu definieren",
  generalErrorMessage: "Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.",
  copyConfirmation: "In die Zwischenablage kopiert!",
  copyError: "Kopieren in die Zwischenablage fehlgeschlagen!",
  noData: "No Data",
  noAssignment: "No Assgignment",
  createOrSelectTags: "Tags erstellen oder auswählen",
  noMeasurementsFound: "Keine Maßeinheiten gefunden",
  resetPassword:
    "Sie werden auf eine externe Website weitergeleitet, um Ihr Passwort zurückzusetzen. Möchten Sie fortfahren?",
};
